import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["token"]
  static values = {
    siteKey: String,
    action: String
  }

  async submit(event) {
    if (this._skipRecaptchaOnce) {
      this._skipRecaptchaOnce = false
      return
    }

    if (!this.shouldRunRecaptcha()) return
    if (event) event.preventDefault()
    if (this._recaptchaSubmitting) return

    this._recaptchaSubmitting = true
    const token = await this.fetchRecaptchaToken()
    if (this.hasTokenTarget) this.tokenTarget.value = token || ""
    this._recaptchaSubmitting = false

    this._skipRecaptchaOnce = true
    this.element.requestSubmit()
  }

  reset() {
    if (this.hasTokenTarget) this.tokenTarget.value = ""
    this._recaptchaSubmitting = false
    this._skipRecaptchaOnce = false
  }

  shouldRunRecaptcha() {
    return this.hasTokenTarget && this.hasSiteKeyValue && !!this.siteKeyValue
  }

  fetchRecaptchaToken() {
    if (typeof window === "undefined") return Promise.resolve("")
    if (!this.hasSiteKeyValue || !this.siteKeyValue) return Promise.resolve("")
    if (typeof grecaptcha === "undefined" || !grecaptcha.execute || !grecaptcha.ready) {
      return Promise.resolve("")
    }

    return new Promise(resolve => {
      grecaptcha.ready(() => {
        grecaptcha.execute(this.siteKeyValue, { action: this.actionValue || "form_submit" })
          .then(token => resolve(token))
          .catch(() => resolve(""))
      })
    })
  }
}
